var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.707 10.707C6.51947 10.8944 6.26516 10.9998 6 10.9998C5.73484 10.9998 5.48053 10.8944 5.293 10.707L0.793001 6.20697C0.605529 6.01944 0.500214 5.76513 0.500214 5.49997C0.500214 5.2348 0.605529 4.9805 0.793001 4.79297L5.293 0.292969C5.4816 0.11081 5.73421 0.0100166 5.9964 0.012295C6.2586 0.0145733 6.50941 0.119743 6.69482 0.30515C6.88023 0.490558 6.9854 0.741371 6.98767 1.00357C6.98995 1.26576 6.88916 1.51837 6.707 1.70697L4 4.49997L13.5 4.49997C13.7652 4.49997 14.0196 4.60533 14.2071 4.79286C14.3946 4.9804 14.5 5.23475 14.5 5.49997C14.5 5.76519 14.3946 6.01954 14.2071 6.20708C14.0196 6.39461 13.7652 6.49997 13.5 6.49997L4 6.49997L6.707 9.29297C6.89447 9.4805 6.99979 9.7348 6.99979 9.99997C6.99979 10.2651 6.89447 10.5194 6.707 10.707Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.cb37153bd3c6cb1c5f228899933e30cd.svg";
export { ForwardRef as ReactComponent };